export default class HorizontalScroller {
    constructor(mover) {


        this.mover = mover;
        this.throttle = null;
        this.offset = null;
        this.init();
    }

    init() {
        this.setOffset();
        this.translateMover();

        document.body.onscroll = () => {
            if (!this.throttle) {
                this.throttle = setTimeout(() => {
                    this.setOffset();
                    this.translateMover();
                    this.throttle = null;
                }, 10);
            }
        }
    }

    setOffset() {
        this.offset = this.mover.getBoundingClientRect();
    }

    translateMover() {
        let posX = ( -1 *  (this.offset.top - window.innerHeight + 200) * (100 / window.innerHeight) );
        let iconHalfWidth = (this.mover.querySelector('svg').width.baseVal.value / 2);
        if (this.offset.top < window.innerHeight && this.offset.top >= -400) {
            this.mover.style.transform="translateX(calc(" + posX + '% - ' + iconHalfWidth + 'px - 1.5rem))';
        }
    }
}